const lang = {
  english: {
    search: "Search",
    gptSearchPlaceHolder: "What would you like to watch today?",
  },
  tamil: {
    search: "தேடு",
    gptSearchPlaceHolder: "இன்று நீங்கள் எதைப் பார்க்க விரும்புகிறீர்கள்?",
  },
};

export default lang;
